<template>
  <div>
    <div v-if="showPendingOrderModal" class="bottom-order-sticky-widget">
      <pending-order-modal></pending-order-modal>
    </div>
    <div v-else-if="valideOrders.length > 0" ref="trackWrapper" class="mb16">
      <div v-if="filteredOrdersCount == 1" class="scroll-target">
        <nxg-track-widget
          :orderSummary="filteredOrders[0]"
          :currentIndex="0"
          :isStickyBottom="false"
          :moduleProps="modulePropsData"
          :totalOrderCount="filteredOrdersCount"
          :isNgAdvanceOrder="isNgAdvanceOrder"
        />
      </div>
      <div
        class="flex-column nxg-track-ord scroll-target"
        v-else-if="filteredOrdersCount > 1"
      >
        <Carousel
          v-model="currentIndex"
          :items-to-show="1"
          :wrap-around="false"
          :mouse-drag="true"
          :touch-drag="true"
          :transition="400"
          :snap-align="'center'"
        >
          <Slide v-for="(order, index) in filteredOrders" :key="index">
            <div class="nxg-track-order-item">
              <nxg-track-widget
                :orderSummary="order"
                :currentIndex="currentIndex"
                :isStickyBottom="false"
                :moduleProps="modulePropsData"
                @update-index="handleIndexChange"
                :totalOrderCount="filteredOrdersCount"
                :isNgAdvanceOrder="isNgAdvanceOrder"
              />
            </div>
          </Slide>
          <template #addons>
            <Pagination />
          </template>
        </Carousel>
      </div>
      <transition name="slide-up-down">
        <div
          class="bottom-order-sticky-widget"
          v-show="showStickyWidget && !disableStickyFooter && !isOrderTerminal"
        >
          <nxg-track-widget
            :orderSummary="filteredOrders[this.currentIndex]"
            :currentIndex="currentIndex"
            :isStickyBottom="true"
            :moduleProps="modulePropsData"
            :totalOrderCount="filteredOrdersCount"
            :isNgAdvanceOrder="isNgAdvanceOrder"
          />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import NxgTrackWidget from "./NxgTrackWidget.vue";
import PendingOrderModal from "./PendingOrderModal.vue";
import NxgTrackOrders from "../assets/FallbackData/NxgTrackOrder.json";
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
import { nextTick } from "vue";
import {
  fireHomeTrackAmplitudeEvent,
} from "../helpers/utility";
import Utility from "../helpers/utility";
import { Carousel, Slide, Pagination } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { getVariationNameForCampaignKey } from "xlabs-sdk";
import {
  NG_TRACK_CAMPAIGN_KEY,
  PWA_WORKSPACE_ID,
  SHOW_NG_TRACK_VARIATION,
  NG_DITA_CAMPAIGN_KEY,
  NG_ADVANCE_ORDER_CAMPAIGN_KEY,
  SHOW_NG_ADVANCE_ORDER_VARIATION
} from "../helpers/xlabsConstants";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { ORDER_TYPE } from "../helpers/paymentConstants";

export default {
  components: {
    NxgTrackWidget,
    Carousel,
    Slide,
    Pagination,
    PendingOrderModal,
  },
  name: "NxgTrackOrder",
  setup() {
    return {
      NxgTrackOrders,
    };
  },
  props: ["data", "moduleProps"],
  data() {
    return {
      modulePropsData: {},
      currentIndex: 0,
      currentTrackingId: "",
      isSnapping: false,
      showStickyWidget: false,
      intervalList: [],
      advancePollTimeouts: [],
      statusHitInterval: 60000,
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined" &&
      this.moduleProps != "null"
        ? JSON.parse(this.moduleProps)
        : NxgTrackOrders.moduleProps;
    // active orders api call
   
    setTimeout(() => {
      LocalStorageFunc.isLoggedIn() && this.getActiveOrders();
    }, 100);
  },
  beforeUnmount() {
    // if (this.observer) this.observer.disconnect();
    // clear all intervals
    this.clearAllIntervals();
  },
  watch: {
    currentIndex(newVal, oldVal) {
      this.handleCurrentIndexChange(newVal, oldVal);
    },
    filteredOrders(newVal) {
      if (newVal.length > 0) {
        this.getTrackingDataForItem(this.currentIndex);
        this.initObserver();
      }
    },
    allOrderData(newVal) {
      if (newVal.length > 0 && newVal?.[this.currentIndex]?.orderStatus) {
        fireHomeTrackAmplitudeEvent(
          "order_tracking_widget_impression",
          "Active Order widget shown",
          newVal[this.currentIndex],
          this.filteredOrders?.[this.currentIndex],
          this.currentIndex,
          "",
          this.filteredOrdersCount,
        );
      }
    },
  },
  computed: {
    activeOrders() {
      
      const advOrders = this.$store.state.NxgTrackOrder?.activeOrders?.advanceOrders || [];
      const orders = this.$store.state.NxgTrackOrder?.activeOrders?.orders || [];
      const mergedOrders = [ ...orders,...advOrders ];
      return mergedOrders;
    },
    disableStickyFooter() {
      return (
        this.filteredOrders[this.currentIndex]?.orderCurrentState == 9 ||
        this.filteredOrders[this.currentIndex]?.orderStatus !== "SUCCESS" ||
        this.filteredOrders[this.currentIndex]?.orderCurrentState == 5
      );
    },
    shouldResetIndex() {
      return (
        this.$store.state.NxgTrackOrder?.resetInterval?.[this.currentIndex] ||
        false
      );
    },
    allOrderData() {
      return this.$store.state.NxgTrackOrder?.allOrderData || [];
    },
    isOrderTerminal() {
      const orderStatusData =
        this.$store.state.NxgTrackOrder?.allOrderData?.[this.currentIndex];
      return (
        orderStatusData &&
        (orderStatusData.orderStatusCode === 9 ||
          orderStatusData.orderStatusCode === 5 ||
          orderStatusData.orderStatus !== "SUCCESS")
      );
    },
    valideOrders() {
      // order should be delivery, non irctc, non advance

      const validOrders = (this.activeOrders || []).filter(
        (order) =>
          order &&
          order.deliveryOrderType?.deliveryTypeCode !== ORDER_TYPE.IRCTC &&
          order.irctcOrder == false,
      );
      return validOrders || [];
    },
    validOrderCount() {
      return this.valideOrders.length || 0;
    },
    filteredOrdersCount() {
      return this.filteredOrders?.length || 0;
    },
    showPendingOrderModal() {
      return this.$store.state.NxgTrackOrder?.showPendingOrderModal;
    },
    filteredOrders() {
      let filteredOrders = [];
      if (this.valideOrders.length == 1) {
        if (
          (this.valideOrders[0]?.deliveryOrderType?.deliveryTypeCode ===
              ORDER_TYPE.PICKUP ||
              this.valideOrders[0]?.deliveryOrderType?.deliveryTypeCode == ORDER_TYPE.DINEIN ||
              this.valideOrders[0]?.deliveryOrderType?.deliveryTypeCode == ORDER_TYPE.DELIVERY) ||
          this.isNgAdvanceOrder
        ) { 
          filteredOrders.push(this.valideOrders[0]);
        }
      } else {
        filteredOrders = (this.valideOrders || []).filter((order) => {
          if (
            ((order?.deliveryOrderType?.deliveryTypeCode ===
              ORDER_TYPE.PICKUP ||
              order.deliveryOrderType?.deliveryTypeCode == ORDER_TYPE.DINEIN)) ||
            (order.deliveryOrderType?.deliveryTypeCode == ORDER_TYPE.DELIVERY)
          ) {
            return (
              order &&
              order.orderStatus === "SUCCESS" &&
              order.orderCurrentState !== 9 &&
              order.orderCurrentState !== 5
            );
          }
        });
      }

      // if (filteredOrders.length == 0 && this.valideOrders.length > 0 && ) {
      //   filteredOrders.push(this.valideOrders[0]);
      // }
      return filteredOrders;
    },
    
    isNgAdvanceOrder() {
      const ngAdvanceOrderVariation = getVariationNameForCampaignKey(
        PWA_WORKSPACE_ID,
        NG_ADVANCE_ORDER_CAMPAIGN_KEY,
      );
      return ngAdvanceOrderVariation === SHOW_NG_ADVANCE_ORDER_VARIATION;
    },
  },
  methods: {
    showStickyForOrder(itemIndex) {
      return (
        this.filteredOrders?.[itemIndex]?.orderCurrentState !== 9 ||
        this.filteredOrders?.[itemIndex]?.orderCurrentState !== 5 ||
        this.filteredOrders?.[itemIndex]?.orderStatus !== "SUCCESS"
      );
    },
    async getTrackingDataForItem(index = 0) {
      const currentOrder = this.filteredOrders?.[index];
      const currentOrderId = currentOrder?.id;
      if (
        (currentOrderId && this.intervalList.length <= index) ||
        this.shouldResetIndex
      ) {
        await this.$store.dispatch(keyMapsAction.ORDER_TRACKING_API, {
          orderId: currentOrderId,
          fetchAdvanceOrders: this.isNgAdvanceOrder,
          itemIndex: index,
        });

        this.startOrSchedulePolling(index, currentOrderId, currentOrder);
      } else {
        fireHomeTrackAmplitudeEvent(
          "order_tracking_widget_impression",
          "Active Order widget shown",
          this.$store.state.NxgTrackOrder?.allOrderData?.[index],
          this.filteredOrders?.[index],
          index,
          "",
          this.filteredOrdersCount,
        );
      }
    },
    getAdvancePollWindowSecs() {
      return (this.modulePropsData?.ad_polling_start_mins || 60) * 60;
    },
    isWithinAdvancePollWindow(order = {}) {
      // advanceOrderDeliveryTime is epoch seconds
      const deliveryEpochSecs = order?.advanceOrderDeliveryTime;
      if (!order?.advanceOrder || !deliveryEpochSecs) return true;

      const nowEpochSecs = Math.floor(Date.now() / 1000);
      const diffSecs = deliveryEpochSecs - nowEpochSecs;
      return diffSecs <= this.getAdvancePollWindowSecs();
    },
    startPollingInterval(index, orderId) {
      if (this.intervalList[index]) {
        clearInterval(this.intervalList[index]);
      }
      this.intervalList[index] = setInterval(() => {
        this.$store.dispatch(keyMapsAction.ORDER_TRACKING_API, {
          orderId,
          fetchAdvanceOrders: this.isNgAdvanceOrder,
          itemIndex: index,
        });
      }, this.statusHitInterval);
    },
    startOrSchedulePolling(index = 0, orderId = '', order = {}) {
      if (this.advancePollTimeouts[index]) {
        clearTimeout(this.advancePollTimeouts[index]);
        this.advancePollTimeouts[index] = null;
      }

      if (this.isWithinAdvancePollWindow(order)) {
        this.startPollingInterval(index, orderId);
        return;
      }

      // reserve slot so getTrackingDataForItem does not re-enter before window opens
      if (this.intervalList.length <= index) {
        this.intervalList[index] = null;
      }

      const nowEpochSecs = Math.floor(Date.now() / 1000);
      const delayMs =
        (order.advanceOrderDeliveryTime -
          nowEpochSecs -
          this.getAdvancePollWindowSecs()) *
        1000;

      this.advancePollTimeouts[index] = setTimeout(() => {
        this.startPollingInterval(index, orderId);
        this.advancePollTimeouts[index] = null;
      }, delayMs);
    },
    initObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      nextTick(() => {
        const wrapper = this.$refs.trackWrapper;
        if (!wrapper) return;

        const children = Array.from(wrapper.children).filter((el) =>
          el.classList.contains("scroll-target"),
        );
        if (!children.length) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            const allOutOfView = entries.every(
              (entry) => !entry.isIntersecting,
            );
            this.showStickyWidget =
              allOutOfView && this.showStickyForOrder(this.currentIndex);
          },
          {
            threshold: 0.1,
          },
        );

        children.forEach((el) => this.observer.observe(el));
      });
    },
    clearAllIntervals() {
      this.intervalList.forEach((id) => clearInterval(id));
      this.intervalList = [];
      this.advancePollTimeouts.forEach((id) => clearTimeout(id));
      this.advancePollTimeouts = [];
    },
    getActiveOrders() {
      this.$store.dispatch(keyMapsAction.GET_ACTIVE_ORDERS, {
        fetchAdvanceOrders: this.isNgAdvanceOrder,
      });
    },
    handleIndexChange(newIndex) {
      this.currentIndex = newIndex;
    },
    handleCurrentIndexChange(newVal, oldVal) {
      this.$store.commit(keyMapsMutation.UPDATE_CURRENT_ORDER_INDEX, newVal); 
      if (this.filteredOrders.length > 0) {
        const previousOrder =
          this.$store.state.NxgTrackOrder?.allOrderData?.[oldVal];
        if (
          previousOrder &&
          (previousOrder.orderStatusCode === 9 ||
            previousOrder.orderStatusCode === 5 ||
            previousOrder.orderStatus !== "SUCCESS")
        ) {
          let currentActiveOrders =
            this.$store.state.NxgTrackOrder?.activeOrders?.orders || [];
          currentActiveOrders.splice(oldVal, 1);
          const updatedActiveOrders = {
            orders: currentActiveOrders,
          };
          this.$store.commit(
            keyMapsMutation.UPDATE_HOME_ACTIVE_ORDERS,
            updatedActiveOrders,
          );
          this.$store.commit(keyMapsMutation.UPDATE_ALL_ORDER_DATA, []);
          this.$store.commit(keyMapsMutation.UPDATE_CURRENT_ORDER_INDEX, 0);
          this.currentIndex = 0;
          this.clearAllIntervals();
          this.getTrackingDataForItem(0);
        } else {
          this.getTrackingDataForItem(newVal);
        }
      }
    },
  },
};
</script>
